module.exports = __webpack_public_path__ + "static/img/22hongbao.9a3efcf7.gif";